<template>
  <!-- Gráfico do Plotly na largura do contêiner: o Plotly só mede a largura ao desenhar, e em
       telas estreitas (ou cartões que mudam de tamanho) o gráfico passava da borda -->
  <div ref="box" class="responsive-plot">
    <Plotly
      v-if="width"
      :data="data"
      :layout="{ ...layout, width }"
      :display-mode-bar="false"
      :displaylogo="false"
    />
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";

export default {
  name: "ResponsivePlot",
  components: { Plotly },
  props: {
    data: { type: Array, required: true },
    layout: { type: Object, default: () => ({}) }
  },
  data: () => ({ width: 0, observer: null }),
  mounted() {
    this.measure();
    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.$refs.box);
    } else {
      window.addEventListener("resize", this.measure);
    }
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
    window.removeEventListener("resize", this.measure);
  },
  methods: {
    measure() {
      const width = Math.floor(this.$refs.box.clientWidth);
      if (width > 0 && Math.abs(width - this.width) > 1) this.width = width;
    }
  }
};
</script>

<style scoped>
.responsive-plot {
  width: 100%;
  overflow: hidden;
}
</style>
